import Vue from 'vue'
import Vuex from 'vuex'
import index from "./modules/index"
import axios  from "axios"
import {Message} from 'element-ui'
Vue.use(Vuex)

// 首先声明一个需要全局维护的状态 state,比如 我这里举例的resturantName
const state = {
}
// 注册上面引入的各大模块
const store = new Vuex.Store({
  modules: {
    index,
  },
  state: {
    phyExPeoList:[],//体检人列表
    allUserMsg:{},//获取登录用户所有的信息
  },
  mutations: {
    // 获取体检人列表
    getPhysical(state){
      axios.get(BASE_URL+'/appointment/contacts/contactList').then((res)=>{
        console.log(res);
        state.phyExPeoList = res.data.data;
        state.phyExPeoList.forEach(function(element) {
          if(element.relationship == 0){
            state.allUserMsg = element;
          }
        })
      })
    },
   message(state,data){ 
      Message({
        message: data.message,
        type: data.type,
        center:data.center
      })
    }
  },
  getters:{
    // 获取登录用户所有的信息
    phyExPeoList(state) {
      return  state.phyExPeoList
    },
    allUserMsg (state) {
      return state.allUserMsg
    }
  },
actions:{
   getPhysical({commit}) { 
        return commit ('getPhysical')
    },
    message({commit},data) { 
      return commit ('message',data)
  }
}



})
 
export default store  // 导出store并在 main.js中引用注册。


// WEBPACK FOOTER //
// ./src/store/index.js